import { MtxIcon } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import { STATUS } from '@/enums/status';
import handleNotificationLinkClick from '@/utils/functions/tracking/handleNotificationLinkClick/handleNotificationLinkClick';

import { STATUS_ICON_NOTIFICATION } from './statusIconNotification';
import styles from './styles.module.css';

interface NotificationProps {
  title: string;
  message: string;
  status: STATUS;
  duration: number;
  link?: string | null;
  openInNewTab?: boolean | null;
  paused?: boolean;
  onClose: () => void;
}

const Notification: React.FC<NotificationProps> = ({
  title,
  message,
  status,
  duration,
  link,
  openInNewTab,
  paused = false,
  onClose,
}) => {
  const { t } = useTranslation();
  const icon = STATUS_ICON_NOTIFICATION[status];
  const className = `${styles.notification} ${styles[status]}`;
  const style = { '--toast-duration': `${duration}ms` } as React.CSSProperties;

  const mainContent = (
    <>
      <MtxIcon name={icon} size={24} className={`${styles.icon} ${styles[status]}`} />
      <div className={styles.contentToast}>
        <p className={styles.title}>{title}</p>
        <p className={styles.description}>{message}</p>
      </div>
    </>
  );

  return (
    <div className={className} style={style}>
      <div className={styles.progressBarContainer}>
        <div
          className={`${styles.progressBar} ${styles[status]}`}
          data-testid="notification-progress-bar"
          style={paused ? { animationPlayState: 'paused' } : undefined}
          onAnimationEnd={paused ? undefined : onClose}
        />
      </div>
      {link ? (
        <button
          type="button"
          className={styles.clickableArea}
          onClick={() => handleNotificationLinkClick({ title, link, openInNewTab })}
        >
          {mainContent}
        </button>
      ) : (
        mainContent
      )}
      <div className={styles.notificationCloseIcon}>
        <button
          className={styles.closeButton}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClose();
          }}
          aria-label={t('common.closeNotification')}
        >
          <MtxIcon name="cross" size={24} />
        </button>
      </div>
    </div>
  );
};

export default Notification;
